/**
 * Date 객체나 날짜 형식의 문자열을 원하는 형태의 문자열로 변환하여 반환
 *
 * @example formatDate('2024.1-02', 'yy-MM-dd') -> '24-01-02'
 * @example formatDate('2024.1-02 1:03:31.033', 'Y년 M월 D일 시간: H:mm.fff') -> '2024년 1월 2일 시간: 1:03.033'
 */
export function formatCustomDate(date, format) {
    const d = date instanceof Date ? date : new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const hours = d.getHours();
    const minutes = d.getMinutes();
    const seconds = d.getSeconds();
    const milliSeconds = d.getMilliseconds();
    const formatTokens = {
        yyyy: year,
        yy: year.toString().slice(-2),
        y: year,
        Y: year,
        MM: month.toString().padStart(2, "0"),
        M: month,
        dd: day.toString().padStart(2, "0"),
        d: day,
        D: day,
        HH: hours.toString().padStart(2, "0"),
        H: hours,
        mm: minutes.toString().padStart(2, "0"),
        m: minutes,
        ss: seconds.toString().padStart(2, "0"),
        s: seconds,
        fff: milliSeconds.toString().padStart(3, "0"),
        f: milliSeconds,
    };
    const regex = new RegExp(Object.keys(formatTokens).join("|"), "g");
    return format.replace(regex, (match) => String(formatTokens[match] ?? match));
}
